const apiConfig = {
  host: process.env.REACT_APP_API_BASE_URL_POINTER || 'https://reports.rocketer.com/api-staging',
  calendarKey: process.env.REACT_APP_CALENDAR_KEY
};

export default apiConfig;
